// import React, { useState } from 'react'
// import { AgGridReact } from 'ag-grid-react'; 
// import "ag-grid-community/styles/ag-grid.css"; 
// import "ag-grid-community/styles/ag-theme-quartz.css"; 
// import { useSelector } from 'react-redux';

// const TableComponent = ({report, meters,parameter}) => {
//   const mode = useSelector((state) => state.darkMode);
//   const { isdarkMode } = mode;
//     console.log(report) 
//     console.log(meters)

//     const [rowData, setRowData] = useState([
//         { make: "Tesla", model: "Model Y", price: 64950, electric: true },
//         { make: "Ford", model: "F-Series", price: 33850, electric: false },
//         { make: "Toyota", model: "Corolla", price: 29600, electric: false },
//       ]);

//     const columns = [{field:'date',pinned: "left", }]
    
//       meters.map((i)=>{
//             columns.push({field:i}) 
//       })
//       console.log(columns)
      
//       // Column Definitions: Defines the columns to be displayed.
//       const [colDefs, setColDefs] = useState([
//         { field: "make" },
//         { field: "model" },
//         { field: "price" },
//         { field: "electric" }
//       ]);


//   return (
//     <div
//         //   style={gridStyle}
//           className={`${isdarkMode ? "ag-theme-quartz-dark": "ag-theme-alpine"}`}
//           style={{ height: 400 }}
//         >
//           <AgGridReact 
//             rowData={report}
//             columnDefs={columns.length>1 ?columns :[]}
//             pagination={true}
//             domLayout="normal" 
//             defaultColDef={{
//               resizable: true,
//             }}
//             rowHeight={50}
//             suppressHorizontalScroll={false} 
//             overlayNoRowsTemplate={`<span style="color: gray; font-size: 16px;">No rows to show</span>`} 
//           />
//         </div>
//   )
// }

// export default TableComponent






import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

const TableComponent = ({ report, meters, parameter, data }) => {
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);

  const [columns, setColumns] = useState([{ field: "date", pinned: "left" }]);

  useEffect(() => {
    if (meters.length > 0) {
      setColumns([
        { field: "date", pinned: "left", flex: 1, minWidth: 150,width:150 },
        ...meters.map((i) => ({
          field: i,
          valueGetter: (params) => params.data[i],
          flex: 1,
          minWidth: 150,
        })),
      ]);
    }
  }, [meters]);

  // Function to create readable header names
  function sanitizeColumnDefs(columnDefs) {
    return columnDefs.map((colDef) => {
      const isSimpleField = /^[a-zA-Z0-9_]+$/.test(colDef.field);
      if (isSimpleField) return colDef;

      const headerName = colDef.field
        .replace(/\./g, " ") // replace dots with space
        .replace(/-/g, " ") // replace hyphens with space
        .replace(/\s+/g, " ") // normalize spaces
        .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize words

      return {
        ...colDef,
        headerName,
        valueGetter: (params) => params.data[colDef.field],
      };
    });
  }

  const column = sanitizeColumnDefs(columns);
  console.log(column)

  return (
    <div
      className={`${
        isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"
      }  custom-grid`}
      style={{
        "--ag-header-background-color": color.themeConfig.colorPrimary,
        "--ag-header-foreground-color": "#fff",
        "--ag-header-font-size": "28px",
        height: "80vh",
        width: "100%",
        overflowY: "auto",
      }}
    >
      <AgGridReact
        rowData={data?.length > 0 ? data : []}
        columnDefs={column?.length > 1 ? column : []}
        pagination={true}
        domLayout="normal"
        defaultColDef={{
          resizable: true,
          wrapHeaderText: true,       // ✅ allows header text to wrap
          autoHeaderHeight: true,     // ✅ adjusts header height automatically
        }}
        rowHeight={50}
        suppressHorizontalScroll={false}
        overlayNoRowsTemplate={`<span style="color: gray; font-size: 16px;">No rows to show</span>`}
      />
    </div>
  );
};




export default TableComponent;
